/** Home page section anchors — always route to /#section, not current path + hash */
export const isHomeSectionHash = (href) => typeof href === 'string' && href.startsWith('#') && href.length > 1;

/** React Router destination for navbar/footer hash links */
export const homeSectionTo = (href) => ({
  pathname: '/',
  hash: href.slice(1),
});
